import { environment } from '../../environments/environment'

export const serverAddresses = {
  api: environment.API_URL,
}
